"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ModuleRegistryFactory_1 = tslib_1.__importDefault(require("../module/ModuleRegistryFactory"));
class ReportPendingRequests {
    constructor() {
        this.unreported = [];
    }
    send(request, next, prev) {
        let clearPendingCB;
        if (!ModuleRegistryFactory_1.default.getModuleContext()) {
            // We are not yet able to report pending requests to the boot
            // application. Store these locally so that we can report them when
            // we get setup with the boot application
            const pendingMessage = { description: request.description };
            this.unreported.push(pendingMessage);
            clearPendingCB = {
                failure: (message) => {
                    this.removePending(pendingMessage, false, message);
                },
                success: () => {
                    this.removePending(pendingMessage, true);
                }
            };
        }
        else {
            for (let i = 0; i < this.unreported.length; i++) {
                this.unreported[i].remoteCallback =
                    ModuleRegistryFactory_1.default.getModuleContext().addPendingRequest(this.unreported[i].description);
            }
            clearPendingCB = ModuleRegistryFactory_1.default.getModuleContext().addPendingRequest(request.description);
        }
        // Store callback on the reuqest object
        request.clearPendingCB = clearPendingCB;
        next.send(request);
    }
    responseReceived(request, next, prev) {
        // Retrieve the callback that we stored on the request object
        const clearPendingCB = request.clearPendingCB;
        if (request.error) {
            clearPendingCB.failure();
        }
        else {
            clearPendingCB.success();
        }
        prev.responseReceived(request);
    }
    removePending(m, success, err) {
        // Remove from set of unreported pending messages
        for (let i = 0; i < this.unreported.length; i++) {
            if (this.unreported[i] === m) {
                this.unreported.splice(i, 1);
            }
        }
        // Report back to boot application that request is done
        if (m.remoteCallback) {
            if (success) {
                m.remoteCallback.success();
            }
            else {
                m.remoteCallback.failure(err || "Unknown error");
            }
        }
    }
}
exports.default = ReportPendingRequests;
//# sourceMappingURL=ReportPendingRequests.js.map